import styled from 'styled-components';
import NotificationIconSVG from '../../assets/images/notification-icon.svg';

const NotificationIcon = styled.span`
  background: url(\"${NotificationIconSVG}\") no-repeat center center;
  background-size: 21px 25px;
  display: inline-block;
  height: 35px;
  width: 35px;
  position: relative;
  cursor: pointer;
`;

export default NotificationIcon;
